import { schema } from 'normalizr';
import { SCHEMA_TYPE_AUTH_INFO } from '../constants/schemaTypes';

import userSchema from './user';
import orgSchema from './org';

const sessionSchema = new schema.Entity(
  SCHEMA_TYPE_AUTH_INFO,
  {
    user: userSchema,
    org: orgSchema,
    impersonatedUser: userSchema,
  },
  {
    idAttribute: (value) => {
      return value.user ? value.user.id : value.access_token;
    },
    processStrategy: (value) => {
      let expiresAt = Date.now() + value.expires_in * 1000;
      return { ...value, expiresAt };
    },
  },
);

export default sessionSchema;
